import React, { useState, useEffect } from "react";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import { Vessel } from "@/contexts/DealContext";
import { Close } from "@mui/icons-material";

type VesselReviewProps = {
  vessels: Vessel[];
  onChange: (updatedVessels: Vessel[]) => void;
};

const VesselReview: React.FC<VesselReviewProps> = ({ vessels, onChange }) => {
  const [rows, setRows] = useState<Vessel[]>(vessels);
  useEffect(() => {
    onChange(rows);
  }, [rows]);

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      editable: true,
    },
    {
      field: "registration_number",
      headerName: "IMO Number",
      flex: 1,
      editable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      headerAlign: "center",
      align: "center",
      renderCell: (params: GridRenderCellParams) => (
        <Box
          component="span"
          sx={{
            display: "flex", // 👈 ensures flexbox
            alignItems: "center", // 👈 vertical centering
            justifyContent: "center", // 👈 horizontal centering
            cursor: "pointer",
            color: "error.main",
            height: "100%",
          }}
          onClick={() => {
            setRows((prev) => prev.filter((_, index) => index !== params.row.id));
          }}
        >
          <Close sx={{ fontSize: "1rem" }} />
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ height: "100%", width: "50vw" }}>
      <DataGrid
        rows={rows.map((row, index) => ({ id: index, ...row }))}
        columns={columns}
        disableRowSelectionOnClick
        hideFooter
        autoHeight
        density="compact"
        processRowUpdate={(newRow: { id: number }) => {
          const updatedRow: Vessel = newRow as Vessel;
          setRows((prev) => prev.map((row, index) => (index === newRow.id ? updatedRow : row)));
          return { ...newRow };
        }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
        <Button
          color="info"
          onClick={() =>
            setRows((rows) => [
              ...rows,
              {
                id: rows.length,
                name: "",
                registration_number: "",
              },
            ])
          }
        >
          Add Vessel
        </Button>
      </Box>
    </Box>
  );
};

export default VesselReview;
